<template>
  <Modal title="老师对学生的评价" v-model="visible">
    <Form v-show="!isUpdate" class="feedback form" label-position="top">
      <Row>
        <Col :span="22">
          <Form-item label="学习内容评价：">
            <label>{{ feedback.learnedComment }}</label>
          </Form-item>
          <Form-item label="表现好的评价：">
            <label>{{ feedback.goodComment }}</label>
          </Form-item>
          <Form-item label="可以改进的评价：">
            <label>{{ feedback.betterComment }}</label>
          </Form-item>
          <Form-item label="老师评论时间: ">
            <label>{{ feedbackTime }}</label>
          </Form-item>
        </Col>
      </Row>
    </Form>
    <Form v-show="isUpdate" ref="feedbakcForm" :model="feedback" :rules="feedbackRule"
      class="feedback form" label-position="top">
      <Row>
        <Col :span="22">
          <Form-item label="学习内容评价：" prop="learnedComment">
            <Input type="textarea" :autosize="{minRows: 3,maxRows: 5}" :maxlength="300"
              v-model="feedback.learnedComment" ></Input>
          </Form-item>
          <Form-item label="表现好的评价：" prop="goodComment">
            <Input type="textarea" :autosize="{minRows: 3,maxRows: 5}" :maxlength="300"
              v-model="feedback.goodComment" ></Input>
          </Form-item>
          <Form-item label="可以改进的评价：" prop="betterComment">
            <Input type="textarea" :autosize="{minRows: 3,maxRows: 5}" :maxlength="300"
              v-model="feedback.betterComment" ></Input>
          </Form-item>
        </Col>
      </Row>
    </Form>
    <div slot="footer">
      <Button type="text" size="large" @click="visible=false">取消</Button>
      <Button v-show="!isUpdate && !readonly" type="primary" size="large" @click="isUpdate=true" >编辑</Button>
      <Button v-show="isUpdate" type="primary" size="large" :loading="loadingUpdate" @click="update" >保存</Button>
    </div>
  </Modal>
</template>
<style>
  .feedback .ivu-form-item {
    margin-bottom: 10px
  }
  .feedback .ivu-form-item-label {
    font-size: 16px;
    font-weight: 600
  }
  .feedback .ivu-form-item-content label {
    line-height: 30px
  }
</style>
<script>
  export default {
    name: 'BookTchFeedbackModal',
    props: {
      value: {
        type: Boolean,
        default: false
      },
      openedId: {
        type: Number
      },
      readonly: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        visible: this.value,
        isUpdate: false,
        loadingUpdate: false,
        feedbackTime: '',
        feedback: {
        },
        feedbackRule: {
          learnedComment: [
            { type: 'string', required: true, message: '学习内容评价', trigger: 'blur' }
          ],
          goodComment: [
            { type: 'string', required: true, message: '表现好的评价', trigger: 'blur' }
          ],
          betterComment: [
            { type: 'string', required: true, message: '请填写可以改进的评价', trigger: 'blur' }
          ]
        }
      }
    },
    methods: {
      onLoad () {
        let self = this
        let loadMsg = this.$Message.loading('正在加载中...', 0)
        self.$http.get('/bookTchFeedback/queryByLsnOpenId', { params: {lsnOpenId: self.openedId} }).then(function (res) {
          loadMsg()
          if (!res || !res.data) {
            self.$emit('on-close')
            return
          }
          self.visible = true
          self.feedback = res.data
          self.feedbackTime = res.data.gmtModified
        })
      },
      update () {
        let self = this
        this.$refs.feedbakcForm.validate((valid) => {
          if (!valid) {
            return
          }
          self.loadingUpdate = true
          let params = self.feedback
          params.lsnOpenId = self.openedId
          self.$http.post('/bookTchFeedback/update', params).then(function (res) {
            self.loadingUpdate = false
            if (res && res.data > 0) {
              self.$Message.success('保存成功!')
              self.visible = false
            }
          }).catch(function (e) {
            self.loadingUpdate = false
          })
        })
      }
    },
    watch: {
      value (val) {
        if (val === true) {
          this.onLoad()
        } else {
          this.feedback = {}
          this.visible = val
        }
      },
      visible (val) {
        this.isUpdate = false
        this.$emit('input', val)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// BookTchFeedbackModal.vue?e455e30c